.grid {
  display: grid;
  inline-size: min(100%, 36rem);
  aspect-ratio: 1;
  grid-template-rows: repeat(9, 1fr);
  border: 0.1875rem solid var(--color-grid-strong);
  border-radius: var(--radius-small);
  overflow: hidden;
  background: var(--color-grid-strong);
  box-shadow: var(--shadow-surface);
}

.row {
  display: grid;
  min-block-size: 0;
  grid-template-columns: repeat(9, 1fr);
}

.cell {
  position: relative;
  display: grid;
  min-inline-size: 0;
  min-block-size: 0;
  padding: 0;
  place-items: center;
  border: 0;
  border-inline-end: 1px solid var(--color-grid-line);
  border-block-end: 1px solid var(--color-grid-line);
  border-radius: 0;
  color: var(--color-entry);
  background: var(--color-board-cell);
  font-size: clamp(1rem, 5.2vw, 2rem);
  font-weight: 650;
  cursor: pointer;
  touch-action: manipulation;
}

.cell[data-box-column='end'] {
  border-inline-end: 0.1875rem solid var(--color-grid-strong);
}

.cell[data-box-row='end'] {
  border-block-end: 0.1875rem solid var(--color-grid-strong);
}

.cell[data-fixed='true'] {
  color: var(--color-text);
  background: var(--color-fixed-cell);
  font-weight: 800;
}

.cell[data-selected='true'] {
  background: var(--color-selected-cell);
  box-shadow: inset 0 0 0 0.1875rem var(--color-accent);
}

.cell[data-conflict='true'] {
  text-decoration: underline wavy var(--color-danger);
  text-decoration-thickness: 0.125rem;
}

.cell[data-incorrect='true'] {
  box-shadow: inset 0 0 0 0.1875rem var(--color-danger);
  text-decoration: underline double var(--color-danger);
  text-decoration-thickness: 0.125rem;
}

.cell[data-selected='true'][data-incorrect='true'] {
  box-shadow:
    inset 0 0 0 0.1875rem var(--color-accent),
    inset 0 0 0 0.375rem var(--color-danger);
}

.cell:focus-visible {
  z-index: 2;
  outline-offset: -0.25rem;
}

.candidates {
  display: grid;
  inline-size: 100%;
  block-size: 100%;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  color: var(--color-text-muted);
  font-size: clamp(0.42rem, 1.7vw, 0.72rem);
  font-weight: 700;
}

.candidates span {
  display: grid;
  place-items: center;
}

.conflictMark {
  position: absolute;
  inset-block-start: 0.05rem;
  inset-inline-end: 0.15rem;
  color: var(--color-danger);
  font-size: 0.65rem;
  font-weight: 900;
}

.paused {
  display: grid;
  inline-size: min(100%, 36rem);
  aspect-ratio: 1;
  padding: var(--space-5);
  place-items: center;
  border: 0.1875rem solid var(--color-grid-strong);
  border-radius: var(--radius-small);
  color: var(--color-text-muted);
  background: var(--color-fixed-cell);
  font-weight: 750;
  text-align: center;
}

@media (forced-colors: active) {
  .cell[data-selected='true'] {
    outline: 0.25rem solid Highlight;
    outline-offset: -0.25rem;
  }

  .cell[data-incorrect='true'] {
    outline: 0.25rem double Mark;
    outline-offset: -0.375rem;
  }
}
